import images from "./images";

export function getImages(name: "flash" | "limited"): { bg: string } {
  if (name === "flash") {
    return { bg: images.bg_flash_sale };
  }

  return { bg: images.bg_limited_offer };
}
